import { render, staticRenderFns } from "./extend.vue?vue&type=template&id=1bb46ccf&"
import script from "./extend.vue?vue&type=script&lang=js&"
export * from "./extend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1bb46ccf', component.options)
    } else {
      api.reload('1bb46ccf', component.options)
    }
    module.hot.accept("./extend.vue?vue&type=template&id=1bb46ccf&", function () {
      api.rerender('1bb46ccf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/extend/extend.vue"
export default component.exports